import CascaderOptionsSingle from './Index.vue'

CascaderOptionsSingle.install = function(Vue) {
  Vue.component(CascaderOptionsSingle.name, CascaderOptionsSingle)
}

export default CascaderOptionsSingle
